import React, { Component } from 'react';
import cx from 'classnames';
import { IMAGES } from 'src/constants';
import { Convert } from 'src/helpers';
import styles from './_mobileOneTimeTransactions.module.scss';

export default class MobileOneTimeTransactions extends Component {
  render() {
    const {
      amount,
      handleAmountChange,
      isLoading,
      handleOnSubmit,
      errors,
      checkoutDetail,
      minAmount,
    } = this.props;
    return (
      <div className={styles['mobile-sip-transactions']}>
        <div>
          <div className={styles['banner']}>
            <div className={styles['banner-inner']}>
              <div className={styles['banner-left']}>
                <img
                  src={checkoutDetail?.oneClickCheckout?.partner?.logo || IMAGES.MOTILAL_OSWAL}
                  alt="img"
                />
              </div>
              <div className={styles['banner-right']}>
                <div className={styles['banner-right-title']}>
                  {Convert.toCapitalizeLetters(checkoutDetail?.oneClickCheckout?.partner?.name)}
                </div>
              </div>
            </div>
          </div>

          <div className={styles['divider']} />

          <div className={styles['detail']}>
            <div className={styles['detail-left']}>
              <div className={styles['detail-title']}>Customer Name</div>
              <div className={styles['detail-sub-title']}>
                {checkoutDetail?.oneClickCheckout?.name || '-'}
              </div>
            </div>
            <div className={styles['detail-right']}>
              <div className={styles['detail-title']}>Folio Number</div>
              <div className={styles['detail-sub-title']}>
                {checkoutDetail?.oneClickCheckout?.folioNumber || '-'}
              </div>
            </div>
          </div>

          <div className={styles['divider-two']} />
          <div className={styles['sip-title']}>
            Investing in {checkoutDetail?.oneClickCheckout?.fundName}
          </div>
          <div className={styles['monthly-title']}>Lumpsum amount to be invested</div>

          <div className={styles['input-group']}>
            <div className={styles['input-container']}>
              <div className={cx(styles['input-box'], styles['input-box-amount'])}>
                <span>₹ </span>
                <input type="number" value={amount} onChange={handleAmountChange} />
              </div>
            </div>
            <div className={cx('input-error', styles['amount-input-error'])}>
              {errors?.e_amount}
            </div>
          </div>
          <div className={styles['min-inv']}>
            Min investment {Convert.toCurrencyValue(minAmount || 0)}
          </div>
        </div>
        <div className={styles['powered-by']}>powered by savvy</div>
        <div className={styles['footer-spacer']} />
        <div
          className={cx(styles['footer'], {
            [styles['disabled-footer']]: isLoading,
          })}
        >
          <button onClick={handleOnSubmit} disabled={isLoading}>
            {isLoading ? 'LOADING...' : 'INVEST NOW'}
          </button>
        </div>
      </div>
    );
  }
}
